import {useField} from "formik";

const TextField = (props) => {
    const [field] = useField(props);
    return (
        <input type="text" {...field} {...props} />
    );
};

export default TextField;